/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/questionStatistics',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '问卷填写统计',
      icon: 'component',
    },
    children: [
      {
        path: '/questionStatistics/questionStatistics',
        component: () => import('@/myviews/questionnaireActivity/questionStatistics/questionStatistics.vue'),
        alwaysShow: false,
        name: 'QuestionStatistics',
        meta: {
          title: '问卷填写统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/questionnaireActivity/questionStatistics.js